import { cn } from "@/libs/utils";

const ArrowUpIconWebView = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.4702 2.47007C11.6108 2.32962 11.8014 2.25073 12.0002 2.25073C12.1989 2.25073 12.3895 2.32962 12.5302 2.47007L20.0302 9.97007C20.1038 10.0387 20.1629 10.1215 20.2039 10.2135C20.2449 10.3055 20.267 10.4048 20.2687 10.5056C20.2705 10.6063 20.252 10.7063 20.2143 10.7997C20.1766 10.8931 20.1204 10.9779 20.0492 11.0491C19.978 11.1203 19.8931 11.1765 19.7998 11.2142C19.7064 11.2519 19.6063 11.2704 19.5056 11.2687C19.4049 11.2669 19.3056 11.2448 19.2136 11.2039C19.1216 11.1629 19.0388 11.1038 18.9702 11.0301L12.7502 4.81007V21.0001C12.7502 21.199 12.6711 21.3898 12.5305 21.5304C12.3898 21.6711 12.1991 21.7501 12.0002 21.7501C11.8012 21.7501 11.6105 21.6711 11.4698 21.5304C11.3292 21.3898 11.2502 21.199 11.2502 21.0001V4.81007L5.03015 11.0301C4.96149 11.1038 4.87869 11.1629 4.78669 11.2039C4.69469 11.2448 4.59538 11.2669 4.49468 11.2687C4.39397 11.2704 4.29394 11.2519 4.20056 11.2142C4.10717 11.1765 4.02233 11.1203 3.95112 11.0491C3.8799 10.9779 3.82375 10.8931 3.78603 10.7997C3.74831 10.7063 3.72979 10.6063 3.73156 10.5056C3.73334 10.4048 3.75538 10.3055 3.79637 10.2135C3.83736 10.1215 3.89647 10.0387 3.97015 9.97007L11.4702 2.47007Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ArrowUpIconWebView;
